import React from "react";
import "../styles/SpaceAnimation.css";

const NUM_STARS = 200;

const SpaceAnimation = () => {
  const stars = Array.from({ length: NUM_STARS }).map((_, i) => {
    const style = {
      top: `${Math.random() * 100}vh`,
      left: `${Math.random() * 100}vw`,
      animationDuration: `${1.5 + Math.random() * 2}s`,
      animationDelay: `${Math.random() * 2}s`,
    };
    return <div key={i} className="star" style={style} />;
  });

  return (
    <div className="space-bg">
      
      {stars}
    </div>
  );
};

export default SpaceAnimation;